import {Vue} from 'ui.vue';
import {Vuex} from 'ui.vue.vuex';


import './BXmakerAuthuseremailLoginEmail.css';

import '../BXmakerAuthuseremailInput';
import '../BXmakerAuthuseremailButton';
import '../BXmakerAuthuseremailHeader';
import '../BXmakerAuthuseremailMessage';
import '../BXmakerAuthuseremailCaptcha';

const RegExpEmailValidation = /^(([^<>()[\]\\.,;:\s@\"]+(\.[^<>()[\]\\.,;:\s@\"]+)*)|(\".+\"))@((\[[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\.[0-9]{1,3}\])|(([a-zA-Z\-0-9]+\.)+[a-zA-Z]{2,}))$/;


/**
 * @emits onClickChandeEmail
 */
Vue.component('BXmakerAuthuseremailLoginEmail',
    {
        data: function () {
            return {
                 validationMessage: false,
            };
        },
        computed: {
            ...Vuex.mapState('bxmaker/authuseremail/login', [
                'email', 'sendCodeLoader', 'message', 'error',
                'captchaSrc','captchaWord','captchaLength','captchaLoader',
            ]),
        },
        methods: {
            onInputEmail(value) {
                this.validationMessage = false;
                this.$store.commit('bxmaker/authuseremail/login/setEmail', value);
            },
            onClickSendCode(){
                if(!this.isValidEmail(this.email))
                {
                    this.validationMessage =  this.$root.localize.BXMAKER_AUTHUSEREMAIL_EMAIL_INVALID;
                    return;
                }

                this.$store.dispatch('bxmaker/authuseremail/login/sendCode');

            },
            isValidEmail(email){
                return RegExpEmailValidation.test(email);
            },
            onInputCaptcha(value){
                this.$store.commit('bxmaker/authuseremail/login/setCaptchaWord', value);
            },
            onClickRefreshCaptcha(){
                this.$store.dispatch('bxmaker/authuseremail/login/captchaRefresh');
            },
            onCompleteCaptcha(){
                this.onClickSendCode();
            }
        },
        template: `
            <div class="bxmaker-authuseremail-login-email">                    
                    <BXmakerAuthuseremailHeader>
                        {{$root.localize.BXMAKER_AUTHUSEREMAIL_EMAIL_BLOCK_TITLE}}                        
                    </BXmakerAuthuseremailHeader>
                    
                    <BXmakerAuthuseremailMessage :message="message" :error="error" />
                                      
                    <BXmakerAuthuseremailInput 
                        :title="$root.localize.BXMAKER_AUTHUSEREMAIL_EMAIL" 
                        :value="email" 
                        @onInput="onInputEmail" 
                        @onEnter="onClickSendCode" 
                        :name="email" 
                        :validationMessage="validationMessage"
                    />
                    
                    <BXmakerAuthuseremailCaptcha 
                    :src="captchaSrc"
                    :word="captchaWord"
                    :length="captchaLength"
                    :loader="captchaLoader"                    
                    @onClickRefresh="onClickRefreshCaptcha"
                    @onInput="onInputCaptcha"
                    @onComplete="onCompleteCaptcha"
                     />      
                     
                             
                    
                    <BXmakerAuthuseremailButton 
                        :title="$root.localize.BXMAKER_AUTHUSEREMAIL_GET_CODE"  
                        :loader="sendCodeLoader"
                        @onClick="onClickSendCode" 
                    />
            </div>
        `,
    });